import { render, staticRenderFns } from "./CeppTextArea.vue?vue&type=template&id=2cf20f8b&scoped=true&"
import script from "./CeppTextArea.vue?vue&type=script&lang=js&"
export * from "./CeppTextArea.vue?vue&type=script&lang=js&"
import style0 from "./CeppTextArea.vue?vue&type=style&index=0&id=2cf20f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf20f8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
